<template>
  <b-card class="h-100">
    <b-card-title class="d-flex justify-content-between mb-4">
      Post-it
      <h-b-action-rounded
        v-if="!edit"
        icon="bx bx-edit-alt font-size-8"
        @click.native="edit = true"
      ></h-b-action-rounded>
    </b-card-title>
    <b-row class="mx-1 overflow-auto show-text-area" style="height: 85%" v-if="loaded && !edit">
      {{ note.content }}
    </b-row>
    <b-row v-if="edit" class="d-flex flex-column align-items-center" style="height: 90%">
      <h-f-fields input-type="textarea" v-model="note.content" class="h-75"></h-f-fields>
      <h-b-action text="Modifier" :positive="false" @click.native="editNote"> </h-b-action>
    </b-row>
    <h-e-spinner v-if="!loaded"></h-e-spinner>
  </b-card>
</template>

<script>
import { APIRequest } from '@/node-sdk'

export default {
  name: 'note',

  data() {
    return {
      note: {
        content: null,
      },
      loaded: false,
      edit: false,
    }
  },

  mounted() {
    this.getNotes()
  },

  methods: {
    getNotes() {
      let self = this
      APIRequest.get_object_with_request(process.env.VUE_APP_DASHBOARD_API, 'notes/own', '').then(function (data) {
        self.note = data
        if (!self.note) {
          APIRequest.create(process.env.VUE_APP_DASHBOARD_API, 'notes/own', {
            content: 'Écrivez une note',
            user: null,
            company: '',
          }).then(function (data) {
            self.note = data
          })
        }
        console.log(self.note)
        self.loaded = true
      })
    },

    editNote() {
      APIRequest.create(process.env.VUE_APP_DASHBOARD_API, 'notes/own', this.note)
      this.edit = false
    },
  },
}
</script>

<style scoped>
.show-text-area {
  white-space: pre-line;
}
</style>
